<template>
    <div>
        <b-modal id="deletar-usuario" centered body-class="body-class container deletar-usuario-body pb-0" 
        no-stacking @hidden="$emit('close')" :visible="true">
            <DynamicIcon icon="exclamation" classString="alert-exclamation"/>
            <div class="d-flex">   
                Tem certeza que deseja excluir <b class="ml-1">{{ usuario.name }}</b>?
            </div>
            
            
            <template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn" @click="hideModal">Não</b-button>               
                <b-button pill class="btn-base primary-btn" @click="deletar">Sim</b-button>                
            </template>	
        </b-modal>

        <b-modal id="deletar-usuario-success" centered hide-footer @hidden="$emit('deleted')"
        header-class="deletar-usuario-sub-header" body-class="deletar-usuario-body">
            <DynamicIcon icon="check" :classString="'alert-exclamation'"/>
            Usuário excluído com sucesso!
        </b-modal>
    </div>	
</template>

<script>
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
	name: "ModalDeletarUsuario",
    components:{
        DynamicIcon
    },
    props : { usuario : Object },
    methods:{
        hideModal() {
            this.$bvModal.hide('deletar-usuario')            
        },
        deletar(){
            UserResource.delete(this.usuario.id, {context: "userDelete", showLoader: true})
            .then(() => {
                this.$bvModal.show('deletar-usuario-success')
            })
        }
    }
}
</script>

<style>

.modal-title{
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 2.1px;
	color: #FF612B;
}

.deletar-usuario-sub-header{
    padding-bottom: 5px !important;
}

.deletar-usuario-body{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px !important;
    text-align: center;
}
</style>